import * as THREE from 'three';

/** Lerp */
export function lerp(a, b, t) { return a + (b - a) * t; }

/** Clamp */
export function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

/** Smooth damp (for camera follow, etc.) */
export function smoothDamp(current, target, velocity, smoothTime, dt) {
  const omega = 2 / smoothTime;
  const x = omega * dt;
  const exp = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);
  const change = current - target;
  const temp = (velocity + omega * change) * dt;
  const newVel = (velocity - omega * temp) * exp;
  const newVal = target + (change + temp) * exp;
  return { value: newVal, velocity: newVel };
}

/** Convert HSL to hex */
export function hslToHex(h, s, l) {
  const color = new THREE.Color();
  color.setHSL(h, s, l);
  return color;
}

/** Format large numbers */
export function formatDistance(d) {
  if (d < 1) return `${(d * 1000).toFixed(0)} m`;
  if (d < 100) return `${d.toFixed(1)} km`;
  if (d < 10000) return `${d.toFixed(0)} km`;
  return `${(d / 1000).toFixed(1)} Mm`;
}

/** Easing functions */
export const ease = {
  inOut: (t) => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
  out: (t) => 1 - (1 - t) * (1 - t),
  in: (t) => t * t,
  elastic: (t) => {
    const p = 0.3;
    return Math.pow(2, -10 * t) * Math.sin((t - p / 4) * (2 * Math.PI) / p) + 1;
  }
};

/** Disposable helper - recursively dispose Three.js objects */
export function dispose(obj) {
  if (!obj) return;
  if (obj.geometry) obj.geometry.dispose();
  if (obj.material) {
    if (Array.isArray(obj.material)) {
      obj.material.forEach(m => m.dispose());
    } else {
      obj.material.dispose();
    }
  }
  if (obj.children) {
    [...obj.children].forEach(dispose);
  }
}
